import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import { debug } from "../../utils";
import * as validationService from "./validationService";

function ApiMonitorUriField({ apiMonitorUri, anotherSectionActive, error }) {

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiMonitorUri');
            onChange('');
        } else {
            validationService.validateMonitorUri(apiMonitorUri, 'apiMonitorUri');
        }
        return () => validationService.cleanValidation('apiMonitorUri');
    }, [apiMonitorUri, anotherSectionActive])

    const onChange = (value) => modalDataService.changeApiMonitorUri(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="monitoruri">Monitor URI <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="monitoruri"
                    placeholder="/monitor"
                    onChange={(event => onChange(event.target.value))}
                    value={apiMonitorUri} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiMonitorUriField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = false;//!!addDeviceModal.apiUsername || !!addDeviceModal.apiPassword
    return {
        apiMonitorUri: addDeviceModal.apiMonitorUri || '',
        error: validation.apiMonitorUri,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(ApiMonitorUriField);
